import { httpClient } from "./httpClient";
import type { MeResponse } from "../types";
import { API_ROUTES } from "../constants/apiRoutes";

export const loginApi = async (data: {
  username: string;
  password: string;
}) => {
  return await httpClient(API_ROUTES.LOGIN, {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const getMeApi = async (): Promise<MeResponse> => {
  return await httpClient(API_ROUTES.ME, {
    method: "GET",
  });
};

export const refreshApi = async () => {
  return await httpClient(API_ROUTES.REFRESH, {
    method: "POST",
  });
};